import {
  Timeline as MUITimeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineDot,
  TimelineSeparator,
} from "@mui/lab";
import { Typography } from "@mui/material";
import React from "react";
import { Step } from ".";
import styles from "./timeline.module.scss";

const lightGrey = "rgb(134, 142, 150)";

interface TimelineProps {
  currentStep: number;
  steps: Step[];
}

export const Timeline: React.FC<TimelineProps> = ({ currentStep, steps }) => {
  return (
    <MUITimeline>
      {steps.map((step, index) => {
        return (
          <TimelineItem key={step.label} classes={{ root: styles.item }}>
            <TimelineSeparator className={styles.separator}>
              {index === 0 && <span className={styles.spacer} />}
              <TimelineDot
                classes={{ root: styles.dot }}
                color={index <= currentStep ? "primary" : "grey"}
                variant={index < currentStep ? "filled" : "outlined"}
              />
              {index !== steps.length - 1 && (
                <TimelineConnector className={styles.connector} />
              )}
            </TimelineSeparator>
            <TimelineContent>
              <div className={styles.content}>
                <Typography
                  variant="h6"
                  className={styles.label}
                  color={index <= currentStep ? "primary" : lightGrey}
                >
                  {step.label}
                </Typography>
                <Typography
                  className={styles.description}
                  color={lightGrey}
                  fontSize={14}
                >
                  {step.description}
                </Typography>
              </div>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </MUITimeline>
  );
};
